var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransformatoareCuDouaInfasurari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 82,
    viewBox: "0 0 76 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0V33.8497C23 37.6091 27.8341 39.1416 30 36.0687V36.0687",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 1V34.2889C52 38.1032 47.1691 39.7532 44.8358 36.7359L44 35.6552",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16V34.0828C30 38.0813 35.5204 39.1403 37 35.4256V35.4256",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16V34.0828C37 38.0813 42.5204 39.1403 44 35.4256V35.4256",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 16V35.9036C44 36.9426 45.0087 37.683 46 37.3714V37.3714",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82L51 47.4508C51 43.6792 46.2587 42.0033 43.8885 44.937L43 46.0368",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82L22 48.0241C22 44.1913 26.8699 42.553 29.1866 45.6063L30 46.6784",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66.7109V48.2309C44 44.2242 38.4584 43.1798 37 46.9117V46.9117",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66.7109V48.2309C37 44.2242 31.4584 43.1798 30 46.9117V46.9117",
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66.7109L30 46.388C30 45.3495 28.989 44.6117 28 44.9285V44.9285",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformatoareCuDouaInfasurari);
export default __webpack_public_path__ + "static/media/transformatoare_cu_doua_infasurari.60a45ddc28f033e301afb3d882eaa3bc.svg";
export { ForwardRef as ReactComponent };